import axios from 'axios'
let baseDomain = `${location.protocol}//${location.host}`
let qxyRes = 'https://res.qxueyou.com/'
let serverContext = '/v3/learning'
let htmlContext = '/v3/h5/#'
    // 
const instance = axios.create({

    // baseURL: 'http://192.168.0.196:8078/appraisal-web/' 
     //baseURL: 'http://192.168.41.152:8078/intelligence/stu/' 
    baseURL: '/intelligence/stu'
        //基础路径
        // baseURL: 'https://dev.qxueyou.com/intelligence/stu/'


})



instance.interceptors.request.use(
    (config) => {




        if (localStorage.getItem('tokenn')) {
            config.headers['Authentication'] = localStorage.getItem('tokenn')
        }

        return config
    },
    (error) => {


        return Promise.reject(error)
    }
)


export { instance }